import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from '@/app/App';

// FIRST, and before any component: tokens, then fonts, then base (src/ui/styles/index.css is
// three @imports in that order, so the order cannot be got wrong here). Without this line
// every custom property in the product is undefined and the page renders unstyled — the
// design-system stage shipped the token layer with nothing importing it.
import '@/ui/styles/index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('index.html must contain <div id="root"></div>');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
